<template>
  <div class="list-owner">
    <div 
      v-for="(item,index) of list_history" 
      :key="index"
      class="border-bottom py-3"
      >

      <div v-if="item.type === 'bid'">
        <div class="t-gray">
          {{lg('',{
            en: 'Bid',
            zh: '竞价',
          })}} 
          {{item.amount}}
          {{lg('',{
            en: item.amount>1?'editions':'edition',
            zh: '个',
          })}}
          {{item.blockNumber | blocknum2passedtime}}
        </div>
        <div>
          {{lg('',{
            en: 'by',
            zh: '由',
          })}} 
          <a :href="$store.state.sitecfg.url_network_address_view + item.from" target="_blank" class="c h-c">
            {{item.from | shortAddress}}
          </a>

          <span v-if="item.currency" class="float-right">
            <b class="c">
              {{item.buyValue}} 
              <!-- {{item.currency | uppercase}} -->
              {{lg('', $store.state.web3.account_wallet.find(coin => coin.id == item.currency).names )}}
            </b>
            <span class="t-gray">
              (${{item.buyValue | tokenToUsd(item.currency)}}
              {{lg('',{
                en: 'USD',
                zh: '美元',
              })}})
            </span> 
          </span>
        </div>
      </div>

      <div v-if="item.type === 'cancelBid'">
        <div class="t-gray">
          {{lg('',{
            en: 'Cancel Bid',
            zh: '取消竞价',
          })}} 
          {{item.amount}}
          {{lg('',{
            en: item.amount>1?'editions':'edition',
            zh: '个',
          })}}
          {{item.blockNumber | blocknum2passedtime}}
        </div>
        <div>
          {{lg('',{
            en: 'by',
            zh: '由',
          })}} 
          <a :href="$store.state.sitecfg.url_network_address_view + item.from" target="_blank" class="c h-c">
            {{item.from | shortAddress}}
          </a>
        </div>
      </div>

      <div v-if="item.type === 'mint'">
        <div class="t-gray">
          {{lg('',{
            en: 'Minted',
            zh: '铸造',
          })}} 
          {{item.amount}}
          {{lg('',{
            en: item.amount>1?'editions':'edition',
            zh: '个',
          })}}
          {{item.blockNumber | blocknum2passedtime}}
        </div>
        <div>
          {{lg('',{
            en: 'by',
            zh: '由',
          })}} 
          <a :href="$store.state.sitecfg.url_network_address_view + item.to" target="_blank" class="c h-c">
            {{item.to | shortAddress}}
          </a>
        </div>
      </div>

      <div v-if="item.type === 'sell'">
        <div class="t-gray">
          {{lg('',{
            en: 'Sale',
            zh: '出售',
          })}}
          {{item.amount}}
          {{lg('',{
            en: item.amount>1?'editions':'edition',
            zh: '个',
          })}}
          {{item.blockNumber | blocknum2passedtime}}
        </div>
        <div>
          {{lg('',{
            en: 'by',
            zh: '出售者',
          })}} 
          <a :href="$store.state.sitecfg.url_network_address_view + item.from" target="_blank" class="c h-c">
            {{item.from | shortAddress}}
          </a>

          <span v-if="item.currency" class="float-right">
            <b class="c">
              {{item.buyValue}}
              <!-- {{item.currency | uppercase}} -->
              {{lg('', $store.state.web3.account_wallet.find(coin => coin.id == item.currency).names )}}
            </b>
            <span class="t-gray">
              (${{item.buyValue | tokenToUsd(item.currency)}} 
              {{lg('',{
                en: 'USD',
                zh: '美元',
              })}})
            </span>
          </span>

        </div>
      </div>

      <div v-if="item.type === 'cancelSell'">
        <div class="t-gray">
          {{lg('',{
            en: 'Canceled sale',
            zh: '取消卖单',
          })}} 
          {{item.amount}}
          {{lg('',{
            en: item.amount>1?'editions':'edition',
            zh: '个',
          })}}
          {{item.blockNumber | blocknum2passedtime}}
        </div>
        <div>
          {{lg('',{
            en: 'by',
            zh: '出售者',
          })}} 
          <a :href="$store.state.sitecfg.url_network_address_view + item.from" target="_blank" class="c h-c">
            {{item.from | shortAddress}}
          </a>
        </div>
      </div>

      <div v-if="item.type === 'buy'">
        <div class="t-gray">
          {{lg('',{
            en: 'Bought',
            zh: '购买',
          })}}
          {{item.amount}}
          {{lg('',{
            en: item.amount>1?'editions':'edition',
            zh: '个',
          })}}
          {{item.blockNumber | blocknum2passedtime}}
        </div>
        <div>
          <div>
            {{lg('',{
              en: 'from',
              zh: '购买者',
            })}} 
            <a :href="$store.state.sitecfg.url_network_address_view + item.from" target="_blank" class="c h-c">
              {{item.from | shortAddress}}
            </a>
          </div>
          <div>
            {{lg('',{
              en: 'to',
              zh: '出售者',
            })}} 
            <a :href="$store.state.sitecfg.url_network_address_view + item.to" target="_blank" class="c h-c">
              {{item.to | shortAddress}}
            </a>

            <span v-if="item.currency" class="float-right">
              <b class="c">
                {{item.buyValue}} 
                <!-- {{item.currency | uppercase}} -->
                {{lg('', $store.state.web3.account_wallet.find(coin => coin.id == item.currency).names )}}
              </b>
              <span class="t-gray">
                (${{item.buyValue | tokenToUsd(item.currency)}}
                {{lg('',{
                  en: 'USD',
                  zh: '美元',
                })}})
              </span>
            </span>
            
          </div>
        </div>
      </div>

      <div v-if="item.type === 'trans'">
        <div class="t-gray">
          {{lg('',{
            en: 'Transfered',
            zh: '移交',
          })}}
          {{item.amount}}
          {{lg('',{
            en: item.amount>1?'editions':'edition',
            zh: '个',
          })}}
          {{item.blockNumber | blocknum2passedtime}}
        </div>
        <div>
          <div>
            {{lg('',{
              en: 'from',
              zh: '从',
            })}} 
            <a :href="$store.state.sitecfg.url_network_address_view + item.from" target="_blank" class="c h-c">
              {{item.from | shortAddress}}
            </a>
          </div>

          <div>
            {{lg('',{
              en: 'to',
              zh: '到',
            })}} 
            <a :href="$store.state.sitecfg.url_network_address_view + item.to" target="_blank" class="c h-c">
              {{item.to | shortAddress}}
            </a>
          </div>
        </div>
      </div>

      <!-- <div class="media">
        <span class="ui-avatar mr-2 size-25">
          <img src="/static/pic/default_pic/default_avatar.jpg">
        </span>
        <div class="media-body">
          <div class="t-gray">
            5:00 PM, Oct. 15, 2020
          </div>
          <div>
            Trader Name

            <span class="t-gray float-right">
              <b class="c">
                0 ETH 
              </b>
              ($0.00 USD)
            </span>
          </div>
        </div>
      </div> -->

    </div>
  </div>
</template>

<script>

export default {
  name: 'blockHistory',
  components: {},
  props: [
    'list_history',
  ],
  data() {
    return {
      
    }
  },
  computed: {},
  watch: {},
  methods: {
    
  },
  created() {
    
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  
</style>